import ajax from '../../lib/ajax';

export async function QueryStandingBookDetail(payload:any) {
	//药库台账明细
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStandingBookDetail`,payload)
	return res.data.result
}
export async function QueryStandingBook(payload:any) {
	//查询药库台账
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStandingBook`,payload)
	return res.data.result
}
export async function QuerySupplier(payload:any) {
	//查询所有供货商
	let res = await ajax.post(`/api/services/app/Ghscode/QuerySupplier`,payload)
	return res.data.result
}
export async function QueryPharmacyStandingBookBatchNum(payload:any) {
	//获取药品库存批号信息
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStandingBookBatchNum`,payload)
	return res.data.result
}




export async function CreatePharmacyStockIn(payload:any) {
	//创建入库单(暂存)
	let res = await ajax.post(`/api/services/app/DStockManagement/CreatePharmacyStockIn`,payload)
	return res.data.result
}
export async function CreatePharmacyStockOut(payload:any) {
	//创建出库单(暂存)
	let res = await ajax.post(`/api/services/app/DStockManagement/CreatePharmacyStockOut`,payload)
	return res.data.result
}
export async function CreatePharmacyStockBreakage(payload:any) {
	//创建报损单(暂存)
	let res = await ajax.post(`/api/services/app/DStockManagement/CreatePharmacyStockBreakage`,payload)
	return res.data.result
}
export async function CreatePharmacyStockDiscount(payload:any) {
	//创建调价单(暂存)
	let res = await ajax.post(`/api/services/app/DStockManagement/CreatePharmacyStockDiscount`,payload)
	return res.data.result
}
export async function CreatePharmacyStockCheck(payload:any) {
	//创建盘点单(暂存)
	let res = await ajax.post(`/api/services/app/DStockManagement/CreatePharmacyStockCheck`,payload)
	return res.data.result
}
export async function CreatePharmacyStockRefund(payload:any) {
	//创建退货单(暂存)
	let res = await ajax.post(`/api/services/app/DStockManagement/CreatePharmacyStockRefund`,payload)
	return res.data.result
}


export async function EditPharmacyStockInCheck(payload:any) {
	//入库核对
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockInCheck`,payload)
	return res.data.result
}
export async function EditPharmacyStockOutCheck(payload:any) {
	//出库核对
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockOutCheck`,payload)
	return res.data.result
}
export async function EditPharmacyStockBreakageCheck(payload:any) {
	//报损核对
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockBreakageCheck`,payload)
	return res.data.result
}
export async function EditPharmacyStockCheckCheck(payload:any) {
	//盘点核对
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockCheckCheck`,payload)
	return res.data.result
}
export async function EditPharmacyStockRefundCheck(payload:any) {
	//退货核对
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockRefundCheck`,payload)
	return res.data.result
}
export async function EditPharmacyStockDiscountCheck(payload:any) {
	//调价核对
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockDiscountCheck`,payload)
	return res.data.result
}

export async function EditPharmacyStockInCharge(payload:any) {
	//入库记账
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockInCharge`,payload)
	return res.data.result
}
export async function EditPharmacyStockOutCharge(payload:any) {
	//出库记账
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockOutCharge`,payload)
	return res.data.result
}
export async function EditPharmacyStockBreakageCharge(payload:any) {
	//报损记账
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockBreakageCharge`,payload)
	return res.data.result
}
export async function EditPharmacyStockCheckCharge(payload:any) {
	//盘点记账
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockCheckCharge`,payload)
	return res.data.result
}
export async function EditPharmacyStockRefundCharge(payload:any) {
	//退货记账
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockRefundCharge`,payload)
	return res.data.result
}
export async function EditPharmacyStockDiscountCharge(payload:any) {
	//调价记账
	let res = await ajax.post(`/api/services/app/DStockManagement/EditPharmacyStockDiscountCharge`,payload)
	return res.data.result
}

export async function QueryPharmacyStockIn(payload:any) {
	//入库查询单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockIn`,payload)
	return res.data.result
}
export async function QueryPharmacyStockOut(payload:any) {
	//出库查询单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockOut`,payload)
	return res.data.result
}
export async function QueryPharmacyStockBreakage(payload:any) {
	//报损查询单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockBreakage`,payload)
	return res.data.result
}
export async function QueryPharmacyStorageStockCheck(payload:any) {
	//盘点查询单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStorageStockCheck`,payload)
	return res.data.result
}
export async function QueryPharmacyStockRefund(payload:any) {
	//退货查询单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockRefund`,payload)
	return res.data.result
}
export async function QueryPharmacyStorageStockDiscount(payload:any) {
	//调价查询单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStorageStockDiscount`,payload)
	return res.data.result
}

export async function QueryPharmacyStockInDetailById(payload:any) {
	//入库查询单详情
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockInDetailById`,payload)
	return res.data.result
}
export async function QueryPharmacyStockOutDetailById(payload:any) {
	//出库查询单详情
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockOutDetailById`,payload)
	return res.data.result
}
export async function QueryPharmacyStockBreakageDetailById(payload:any) {
	//报损查询单详情
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockBreakageDetailById`,payload)
	return res.data.result
}
export async function QueryPharmacyStockCheckDetailById(payload:any) {
	//盘点查询单详情
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockCheckDetailById`,payload)
	return res.data.result
}
export async function QueryPharmacyStockRefundDetailById(payload:any) {
	//退货查询单详情
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockRefundDetailById`,payload)
	return res.data.result
}
export async function QueryPharmacyStockDiscountDetailById(payload:any) {
	//调价查询单详情
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockDiscountDetailById`,payload)
	return res.data.result
}


export async function EditDelPharmacyStockIn(payload:any) {
	//删除入库单据
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDelPharmacyStockIn`,payload)
	return res.data.result
}
export async function EditDelPharmacyStockOut(payload:any) {
	//删除出库单据
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDelPharmacyStockOut`,payload)
	return res.data.result
}
export async function EditDelPharmacyStockBreakage(payload:any) {
	//删除报损单据
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDelPharmacyStockBreakage`,payload)
	return res.data.result
}
export async function EditDelPharmacyStockCheck(payload:any) {
	//删除盘点单据
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDelPharmacyStockCheck`,payload)
	return res.data.result
}
export async function EditDelPharmacyStockRefund(payload:any) {
	//删除退货单据
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDelPharmacyStockRefund`,payload)
	return res.data.result
}
export async function EditDelPharmacyStockDiscount(payload:any) {
	//删除调价单据
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDelPharmacyStockDiscount`,payload)
	return res.data.result
}

export async function DeleteStockInDetail(payload:any) {
	//删除入库单据明细
	let res = await ajax.post(`/api/services/app/DStockManagement/DeleteStockInDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockOutDetail(payload:any) {
	//删除出库单据明细
	let res = await ajax.post(`/api/services/app/DStockManagement/DeleteStockOutDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockBreakageDetail(payload:any) {
	//删除报损单据明细
	let res = await ajax.post(`/api/services/app/DStockManagement/DeleteStockBreakageDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockCheckDetail(payload:any) {
	//删除盘点单据明细
	let res = await ajax.post(`/api/services/app/DStockManagement/DeleteStockCheckDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockRefundDetail(payload:any) {
	//删除退货单据明细
	let res = await ajax.post(`/api/services/app/DStockManagement/DeleteStockRefundDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockDiscountDetail(payload:any) {
	//删除调价单据明细
	let res = await ajax.post(`/api/services/app/DStockManagement/DeleteStockDiscountDetail`,{params:payload})
	return res.data.result
}


export async function EditDrugStorageStockRedDashed(payload:any) {
	//红冲
	let res = await ajax.post(`/api/services/app/DStockManagement/EditDrugStorageStockRedDashed`,payload)
	return res.data.result
}
export async function QueryPharmacyReceiptStockIn(payload:any) {
	//查询入库单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyReceiptStockIn`,payload)
	return res.data.result
}
export async function QueryPharmacyReceiptStockOut(payload:any) {
	//查询出库单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyReceiptStockOut`,payload)
	return res.data.result
}
export async function QueryPharmacyReceiptStockBreakage(payload:any) {
	//查询报损单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyReceiptStockBreakage`,payload)
	return res.data.result
}
export async function QueryPharmacyReceiptStockCheck(payload:any) {
	//查询盘点单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyReceiptStockCheck`,payload)
	return res.data.result
}
export async function QueryPharmacyReceiptRefund(payload:any) {
	//查询退货单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyReceiptRefund`,payload)
	return res.data.result
}
export async function QueryPharmacyReceiptDiscount(payload:any) {
	//查询调价单
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyReceiptDiscount`,payload)
	return res.data.result
}



export async function QuryPharmacyWarning(payload:any) {
	//药房有效期预警
	let res = await ajax.post(`/api/services/app/DStockManagement/QuryPharmacyWarning`,payload)
	return res.data.result
}

export async function QueryPharmacyStockWarning(payload:any) {
	//药房库存预警
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyStockWarning`,payload)
	return res.data.result
}

//药房退发药
export async function QueryWeiFaYaoList(payload:any) {
	//未发药患者列表
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryWeiFaYaoList`,payload)
	return res.data.result
}
export async function QuerryFaYaoList(payload:any) {
	//已发药患者列表
	let res = await ajax.post(`/api/services/app/DStockManagement/QuerryFaYaoList`,payload)
	return res.data.result
}
export async function QueryPharmacySend(payload:any) {
	//发药
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacySend`,payload)
	return res.data.result
}
export async function QueryPharmacyBack(payload:any) {
	//退药
	let res = await ajax.post(`/api/services/app/DStockManagement/QueryPharmacyBack`,payload)
	return res.data.result
}
export async function QuerryDispensingDetail(payload:any) {
	//根据处方号获取未发药处方药品详情列表
	let res = await ajax.post(`/api/services/app/DStockManagement/QuerryDispensingDetail`,payload)
	return res.data.result
}
export async function QuerryNotDispensingDetail(payload:any) {
	//根据处方号获取已发药处方药品详情列表
	let res = await ajax.post(`/api/services/app/DStockManagement/QuerryNotDispensingDetail`,payload)
	return res.data.result
}
export async function DispensingSearchData(payload:any) {
	//处方退发药查询Type = 1为发药，2为退药
	let res = await ajax.post(`/api/services/app/DStockManagement/DispensingSearchData`,payload)
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/pharmacy/index.ts